// extracted by mini-css-extract-plugin
export default {"order__wrapper":"OrderList_order__wrapper__hwzDZ","order__list":"OrderList_order__list__CSQkq","order__fullprice":"OrderList_order__fullprice__Vb71w"};